/**
 * 波形ピーク取得フック（タイムラインパネル用の互換ラッパー）。
 *
 * 実装は `src/components/audio-preview/core/` に移設済み（全プレビュー共通化）。
 * このファイルは既存 import を壊さないための薄い再エクスポート。
 */

import { usePeaks, useMultiPeaks } from '../../../components/audio-preview/core/usePeaks';
import type { PeaksResult, PeaksRequest } from '../../../components/audio-preview/core/usePeaks';

export type { WaveformPeaks } from '../../../components/audio-preview/core/peaks';
export type WaveformPeaksResult = PeaksResult;
export type WaveformRequest = PeaksRequest;

export const useMultiWaveformPeaks = useMultiPeaks;

export function useWaveformPeaks(params: {
  /** キャッシュキー（メディアアイテム ID） */
  mediaItemId: string | null | undefined;
  /** Lambda 事前計算の peaks JSON URL */
  waveformUrl?: string | null;
  /** decode フォールバック用の元メディア URL（HLS 不可のため original_url を渡す） */
  fallbackSrc?: string | null;
  enabled: boolean;
}): WaveformPeaksResult {
  const { mediaItemId, waveformUrl, fallbackSrc, enabled } = params;
  return usePeaks({ cacheKey: mediaItemId, waveformUrl, fallbackSrc, enabled });
}
